import { ThemeType } from "@evidenceb/athena-common/modules/Theme";
import type React from "react";
import {
  createContext,
  type Dispatch,
  type SetStateAction,
  useState,
} from "react";
import { v4 as uuid } from "uuid";
import type Session from "../interfaces/Session";
import { StatementHistory } from "../interfaces/Session";
import type { UserType } from "../interfaces/User";

interface SessionContext {
  session: Session;
  setSession: Dispatch<SetStateAction<Session>>;
}

const initialState: Session = {
  sessionId: uuid(),
  userId: "",
  firstname: "",
  lastname: "",
  userProvider: "",
  appProvider: "",
  appVariation: "",
  extra: {},
  statementsFetched: false,
  userType: undefined as any as UserType,
  evidencebId: "",
  app: "",
  soloAI: undefined,
  version: "",
  theme: ThemeType.Light,
  dismissMessages: {
    prmObjectiveLockingConfirmationModal: false,
    prmObjectiveUnlockingConfirmationModal: false,
    specimenGetFullVersionBanner: false,
    specimenSwitchUserModal: false,
    specimenTeacherDashboardModal: false,
    playlistRemoveStudentFromRecipients: false,
    offlineBanner: false,
    deppTestManual: false,
    dahsboardHelpInfo: false,
  },
  flags: {
    useHistoryFrom: StatementHistory.LRS,
    displaySignIn: false,
    logExerciseDetails: false,
  },
  fragments: [],
  athenaEvents: [],
};

// Context init
const sessionStore = createContext<SessionContext>({
  session: initialState,
  setSession: () => null,
});

// Provider init
const { Provider } = sessionStore;

// Final setup
const SessionProvider = ({ children }: { children: React.ReactNode }) => {
  const [session, setSession] = useState(initialState);
  return <Provider value={{ session, setSession }}>{children}</Provider>;
};

export { SessionProvider, sessionStore };
